import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider, useAuth } from './AuthContext';
import PageAuth from './PageAuth';
import Inscription from './Inscription';
import Connexion from './Connexion';
import TableauDeBord from './TableauDeBord';
import VoirSite from './VoirSite';
import EditerSite from './EditerSite';
import MesSoumissions from './MesSoumissions';
import DashboardAdmin from './DashboardAdmin';
import PageClient from './PageClient';
import PageDeveloppeur from './PageDeveloppeur';
import Accueil from './Accueil';
import PageQuiSommesNous from './PageQuiSommesNous';
import PageTarifs from './PageTarifs';
import PageFAQ from './PageFAQ';
import PageContact from './PageContact';
import PageDomaines from './PageDomaines';
import PageConfidentialite from './PageConfidentialite';
import PageConditions from './PageConditions';

function RouteProtegee({ children, typeRequis }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/connexion" />;
  if (typeRequis && user.type !== typeRequis) return <Navigate to="/" />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Accueil />} />
          <Route path="/connexion" element={<Connexion />} />
<Route path="/inscription" element={<Inscription />} />
<Route path="/tableau-de-bord" element={
  <RouteProtegee>
    <TableauDeBord />
  </RouteProtegee>
} />
<Route path="/mes-sites/:id" element={
  <RouteProtegee>
    <VoirSite />
  </RouteProtegee>
} />
<Route path="/mes-sites/:id/editer" element={
  <RouteProtegee>
    <EditerSite />
  </RouteProtegee>
} />
<Route path="/mes-demandes" element={
  <RouteProtegee>
    <MesSoumissions />
  </RouteProtegee>
} />
<Route path="/admin" element={
  <RouteProtegee>
    <DashboardAdmin />
  </RouteProtegee>
} />
          <Route path="/qui-sommes-nous" element={<PageQuiSommesNous />} />
          <Route path="/tarifs" element={<PageTarifs />} />
          <Route path="/faq" element={<PageFAQ />} />
          <Route path="/contact" element={<PageContact />} />
          <Route path="/politique-de-confidentialite" element={<PageConfidentialite />} />
<Route path="/conditions-d-utilisation" element={<PageConditions />} />
          <Route path="/domaines" element={<PageDomaines />} />
          <Route path="/creer-mon-site" element={
            <RouteProtegee>
              <PageClient />
            </RouteProtegee>
          } />
          <Route path="/developpeur" element={
            <RouteProtegee typeRequis="developpeur">
              <PageDeveloppeur />
            </RouteProtegee>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;